export default class CompanyGroup{

    constructor(){

        this.id = 0;
        this.name = "";

    }
}